<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-calendar" /> 生产管理</el-breadcrumb-item>
        <el-breadcrumb-item>生产信息</el-breadcrumb-item>
        <el-breadcrumb-item>内外码导入日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <el-form ref="searchForm" :model="searchForm" label-width="88px" class="search-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="工单号" prop="orderNo">
              <el-input v-model.trim="searchForm.orderNo" clearable placeholder="请输入完整工单号" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="工单ID" prop="workorderSeniorId">
              <el-input v-model.trim="searchForm.workorderSeniorId" clearable placeholder="请输入生产工单ID" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="导入批次" prop="importBatchNo">
              <el-input v-model.trim="searchForm.importBatchNo" clearable placeholder="请输入导入批次号" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="状态" prop="importStatus">
              <el-select v-model="searchForm.importStatus" clearable placeholder="全部状态" style="width:100%">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="文件名" prop="fileName">
              <el-input v-model.trim="searchForm.fileName" clearable placeholder="请输入文件名" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker v-model="searchForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker v-model="searchForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :lg="6" class="search-actions">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table v-loading="loading" :data="rows" border style="width:100%">
        <el-table-column prop="qrcode_orderno" label="工单号" min-width="160" show-overflow-tooltip />
        <el-table-column prop="user_uuid" label="工单ID" min-width="150" show-overflow-tooltip />
        <el-table-column prop="import_batch_no" label="导入批次号" min-width="210" show-overflow-tooltip />
        <el-table-column prop="file_name" label="文件名" min-width="170" show-overflow-tooltip />
        <el-table-column prop="import_status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTag(scope.row.import_status)" size="mini">{{ statusLabel(scope.row.import_status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="csv_total_count" label="总行数" width="82" align="right" />
        <el-table-column prop="success_count" label="成功" width="72" align="right" />
        <el-table-column prop="duplicate_count" label="跨工单重复" width="100" align="right" />
        <el-table-column prop="fail_count" label="失败" width="72" align="right" />
        <el-table-column prop="fail_reasons" label="失败摘要" min-width="220" show-overflow-tooltip />
        <el-table-column prop="create_time" label="上传时间" min-width="160">
          <template slot-scope="scope">{{ formatDate(scope.row.create_time) }}</template>
        </el-table-column>
        <el-table-column prop="import_duration_ms" label="耗时" width="100" align="right">
          <template slot-scope="scope">{{ formatDuration(scope.row.import_duration_ms) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="72" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        background
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[20, 50, 100, 200]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="changePage"
        @size-change="changePageSize"
      />
    </div>

    <el-dialog title="导入日志详情" :visible.sync="detailVisible" width="680px">
      <el-form v-if="detail" class="detail-form" label-width="96px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="工单号"><span class="detail-value">{{ detail.qrcode_orderno }}</span></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工单ID"><span class="detail-value">{{ detail.user_uuid }}</span></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="导入批次"><span class="detail-value">{{ detail.import_batch_no }}</span></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="文件名"><span class="detail-value">{{ detail.file_name }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="状态"><span class="detail-value">{{ statusLabel(detail.import_status) }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="上传来源"><span class="detail-value">{{ detail.username || '-' }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="总行数"><span class="detail-value">{{ detail.csv_total_count }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="有效数量"><span class="detail-value">{{ detail.import_count }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="成功数量"><span class="detail-value">{{ detail.success_count }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="跨工单重复"><span class="detail-value">{{ detail.duplicate_count }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="失败数量"><span class="detail-value">{{ detail.fail_count }}</span></el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="处理耗时"><span class="detail-value">{{ formatDuration(detail.import_duration_ms) }}</span></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传时间"><span class="detail-value">{{ formatDate(detail.create_time) }}</span></el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="失败摘要"><span class="detail-value">{{ detail.fail_reasons || '-' }}</span></el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { getProductionImportLogs, getProductionImportLogDetail } from '@/api/productionImport'

export default {
  name: 'ProductionImportLog',
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      pageIndex: 1,
      pageSize: 20,
      detailVisible: false,
      detail: null,
      searchForm: {
        orderNo: '',
        workorderSeniorId: '',
        importBatchNo: '',
        fileName: '',
        importStatus: '',
        startTime: '',
        endTime: ''
      },
      statusOptions: [
        { value: 0, label: '待处理' },
        { value: 1, label: '处理中' },
        { value: 2, label: '已完成' },
        { value: 3, label: '失败' }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      getProductionImportLogs({
        orderNo: this.searchForm.orderNo,
        workorderSeniorId: this.searchForm.workorderSeniorId,
        importBatchNo: this.searchForm.importBatchNo,
        fileName: this.searchForm.fileName,
        importStatus: this.searchForm.importStatus,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(response => {
        const result = response.data || {}
        this.rows = result.data || []
        this.total = result.total_count || 0
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.pageIndex = 1
      this.load()
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.pageIndex = 1
      this.load()
    },
    changePage(page) {
      this.pageIndex = page
      this.load()
    },
    changePageSize(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.load()
    },
    showDetail(id) {
      getProductionImportLogDetail(id).then(response => {
        this.detail = response.data
        this.detailVisible = true
      })
    },
    statusLabel(value) {
      const item = this.statusOptions.find(option => option.value === Number(value))
      return item ? item.label : '-'
    },
    statusTag(value) {
      return { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' }[Number(value)] || ''
    },
    formatDate(value) {
      return value ? String(value).replace('T', ' ').replace(/\.\d+$/, '') : '-'
    },
    formatDuration(value) {
      if (value === null || value === undefined) return '-'
      const milliseconds = Number(value)
      if (milliseconds < 1000) return `${milliseconds} ms`
      return `${(milliseconds / 1000).toFixed(2)} s`
    }
  }
}
</script>

<style scoped>
.search-form {
  margin-bottom: 8px;
}
.search-actions {
  padding-top: 2px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
.detail-form {
  padding: 0 8px;
}
.detail-form .el-form-item {
  margin-bottom: 10px;
}
.detail-value {
  display: block;
  min-height: 22px;
  overflow-wrap: anywhere;
}
</style>
